/**
 * 权限检查工具函数
 * 用于前端界面权限控制
 */

/**
 * 检查用户是否有指定权限
 * @param {Array} permissions 用户权限列表
 * @param {String} permissionCode 权限编码（格式：模块:操作）
 * @returns {Boolean} 是否有权限
 */
export function hasPermission(permissions, permissionCode) {
  if (!permissions || !Array.isArray(permissions)) {
    return false
  }
  return permissions.includes(permissionCode)
}

/**
 * 检查用户是否有任意一个权限
 * @param {Array} permissions 用户权限列表
 * @param {Array} permissionCodes 权限编码数组
 * @returns {Boolean} 是否有任意一个权限
 */
export function hasAnyPermission(permissions, permissionCodes) {
  if (!permissions || !Array.isArray(permissions)) {
    return false
  }
  if (!permissionCodes || !Array.isArray(permissionCodes)) {
    return false
  }
  return permissionCodes.some(code => permissions.includes(code))
}

/**
 * 检查用户是否有所有权限
 * @param {Array} permissions 用户权限列表
 * @param {Array} permissionCodes 权限编码数组
 * @returns {Boolean} 是否有所有权限
 */
export function hasAllPermissions(permissions, permissionCodes) {
  if (!permissions || !Array.isArray(permissions)) {
    return false
  }
  if (!permissionCodes || !Array.isArray(permissionCodes)) {
    return false
  }
  return permissionCodes.every(code => permissions.includes(code))
}

